var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 56,
    viewBox: "0 0 135 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M125.712 18.1054C128.428 15.4651 131.205 12.8395 134.287 10.4136C132.599 20.1174 130.905 29.8304 129.172 39.7671C128.273 44.9167 127.365 50.1264 126.441 55.426C86.9487 49.0856 48.0405 49.1664 8.70015 55.3823C6.03566 40.1372 3.44483 25.3224 0.751735 9.95848C2.67623 11.7758 4.54522 13.5852 6.38899 15.3702C11.0146 19.8483 15.4815 24.1728 20.2679 28.0834L20.268 28.0834C23.6937 30.8813 26.6324 32.9596 29.2869 34.2724C31.9466 35.5879 34.3486 36.1489 36.6876 35.8749C39.0263 35.601 41.2383 34.4999 43.5318 32.6095C45.821 30.7226 48.2156 28.0293 50.9236 24.5315L50.9238 24.5312C55.04 19.2077 58.8459 13.6332 62.6915 8.00056C64.3089 5.63151 65.9333 3.25217 67.5909 0.87688C69.0421 2.98647 70.4744 5.10557 71.905 7.22223C75.46 12.482 79.0049 17.7268 82.8057 22.7733C85.8432 26.8096 88.4903 29.9109 90.9987 32.0769C93.5111 34.2463 95.9143 35.5037 98.462 35.8019C101.01 36.1002 103.63 35.4304 106.559 33.8876C109.483 32.3473 112.749 29.9188 116.604 26.6519C119.271 24.3954 121.776 21.9485 124.295 19.4874C124.766 19.0268 125.238 18.5658 125.712 18.1054Z",
    fill: "#EDEDED",
    stroke: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorCrown);
export default __webpack_public_path__ + "static/media/VectorCrown.93f86df4992f7396558cf05115294b2f.svg";
export { ForwardRef as ReactComponent };